/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  show: false,
  showDeactivate: false
});

export default function activateAddViewReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'HIDE_ACTIVATE_ADD_VIEW_MODAL': {
      return state.set('show', false);
    }
    case 'SHOW_ACTIVATE_ADD_VIEW_MODAL': {
      return state.set('show', true);
    }
    case 'HIDE_DEACTIVATE_ADD_VIEW_MODAL': {
      return state.set('showDeactivate', false);
    }
    case 'SHOW_DEACTIVATE_ADD_VIEW_MODAL': {
      return state.set('showDeactivate', true);
    }
    default: {
      return state;
    }
  }
}
